<template>
  <main v-if="!mobile" id="base" class="base espacamento">
    <div class="column">
      <div style="width: 100%" class="row border-bottom">
        <div
          style="width: 20%"
          class="row border-right container-img items-center"
        >
          <img
            class="img-logo"
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt=""
            fit="contain"
            crossorigin="*"
          />
        </div>
        <div style="width: 40%" class="row border-right q-pa-sm">
          <span class="row col-12 texto-titulo text-bold">
            Acciona Construcción S.A.
          </span>
          <div class="row col-12">
            <div class="col-8">
              <span class="row texto-titulo-secundario"
                >Rua Olimpiadas, 134, 7º Andar - Vila Olimpia</span
              >
              <span class="row texto-titulo-secundario"
                >São Paulo - SP - CEP: 04.551-100 - FONE: (11) 3047-2902</span
              >
            </div>
            <div class="col">
              <span class="row justify-end texto-titulo-secundario"
                >CNPJ: 03.503.152/0014-10</span
              >
              <span class="row justify-end texto-titulo-secundario"
                >IE: 128.593.586.115</span
              >
            </div>
          </div>
        </div>
        <div style="width: 20%" class="row border-right q-pa-sm">
          <span class="row col-12">
            <span class="row col-12 texto-titulo justify-center text-bold">
              DATAS
            </span>
            <span class="row col-12 texto-titulo-secundario justify-center">
              Impressão: {{ data?.dataAtual }}
            </span>
            <span class="row col-12 texto-titulo-secundario justify-center">
              Criação:
              {{
                dadosTransferencia?.dadosBasicos?.criadoEm
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </span>
          </span>
        </div>
        <div style="width: 20%" class="row q-pa-sm">
          <span class="row col-12">
            <span class="row col-12 texto-titulo text-bold justify-center">
              Nº TRANSFERÊNCIA
            </span>
            <span
              class="row col-12 texto-numero-transferencia text-bold justify-center"
            >
              {{ dadosTransferencia?.dadosBasicos?.numero }}
            </span>
          </span>
        </div>
      </div>
      <div style="width: 100%" class="row q-mt-sm">
        <div class="row" style="width: 100%">
          <span class="row text-bold border-top border-right" style="width: 20%"
            ><span class="q-ml-sm texto-titulo"> ORIGEM: </span></span
          >
          <span
            class="text-bold border-right border-top row justify-center"
            style="width: 30%"
          >
            {{ dadosTransferencia?.dadosBasicos.unidadeNomeOrigem }}
          </span>
          <span
            class="text-bold border-right border-top row justify-center"
            style="width: 30%"
          >
            {{
              `${enderecoUnidade.origem?.endereco}, ${enderecoUnidade.origem?.municipio}-${enderecoUnidade.origem?.uf}`
            }}
          </span>
        </div>
        <div class="row" style="width: 100%">
          <span
            class="row text-bold border-top border-bottom border-right"
            style="width: 20%"
            ><span class="q-ml-sm texto-titulo"> DESTINO: </span></span
          >
          <span
            class="text-bold border-right border-top border-bottom row justify-center"
            style="width: 30%"
          >
            {{ dadosTransferencia?.dadosBasicos.unidadeNomeDestino }}
          </span>
          <span
            class="text-bold border-right border-top border-bottom row justify-center"
            style="width: 30%"
          >
            {{
              `${enderecoUnidade.destino?.endereco}, ${enderecoUnidade.destino?.municipio}-${enderecoUnidade.destino?.uf}`
            }}
          </span>
        </div>
      </div>
    </div>

    <div style="width: 100%" class="q-mt-md border-top conteudo-tabela">
      <div style="width: 100%" class="row border-top border-bottom">
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 10%"
          >ITEM</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >CÓDIGO</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 15%"
          >DESCRIÇÃO</span
        >
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 20%"
          >GRUPO
        </span>
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 20%"
          >Subgrupo
        </span>
        <span
          class="text-bold border-right row justify-center bg-grey-5"
          style="width: 20%; border-right: 1px solid black"
          >Saldo</span
        >
      </div>

      <section style="width: 100%" v-if="dadosTransferenciaSimplificada">
        <div
          v-for="(simplificado, index) in dadosTransferenciaSimplificada"
          :key="index"
          style="width: 100%"
          :class="{ quebra: index == 32 || (index + 1) % 75 == 0 }"
          class="row border-top border-bottom"
        >
          <span
            class="text-bold border-right row items-center justify-center"
            style="width: 10%"
            >{{ index + 1 }}</span
          >
          <span
            class="text-bold border-right items-center row justify-center"
            style="width: 15%"
            >{{ simplificado?.codigo }}</span
          >
          <span
            class="text-bold border-right items-center row justify-center"
            style="width: 15%"
            >{{ simplificado?.descricao }}</span
          >
          <span
            class="text-bold border-right items-center row justify-center"
            style="width: 20%"
            ><span>
              {{ simplificado?.grupo }}
            </span>
          </span>
          <span
            class="text-bold border-right items-center row justify-center"
            style="width: 20%"
            ><span> {{ simplificado?.subgrupo }}</span>
          </span>
          <span
            class="text-bold border-right items-center row justify-center"
            style="width: 20%"
          >
            {{ simplificado?.saldo }}
          </span>
        </div>
      </section>
    </div>

    <div
      v-if="dadoPessoas?.transportador?.nome"
      :style="{ marginTop: 320 / dadosTransferencia?.ativos?.length + 'px' }"
      class="column"
      style="width: 100%"
    >
      <div
        style="width: 100%; height: 60%"
        class="row border-top border-bottom"
      >
        <div style="width: 70%" class="column border-right">
          <div class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right"
              ><span class="q-ml-sm">CONDUTOR:</span></span
            >
            <span
              class="row justify-center text-bold"
              v-if="dadoPessoas?.transportador?.nome"
              style="width: 70%"
              >{{ dadoPessoas?.transportador?.nome }}</span
            >
          </div>
          <div class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right q-pl-sm"
              >MATRICULA:</span
            >
            <span
              class="row justify-center text-bold"
              v-if="dadoPessoas?.transportador?.documento"
              style="width: 70%"
              >{{ dadoPessoas?.transportador?.documento }}</span
            >
          </div>
          <div style="width: 100%" class="row">
            <span style="width: 30%" class="text-bold border-right q-pl-sm"
              >PLACA DO VEICULO:</span
            >
            <span
              class="row justify-center text-bold"
              v-if="dadoPessoas?.transportador?.placaVeiculo"
              style="width: 70%"
              >{{ dadoPessoas?.transportador?.placaVeiculo }}</span
            >
          </div>
        </div>
        <div style="width: 30%">
          <span class="text-bold q-ml-sm" style="width: 100%"
            >OBSERVAÇÃO:
            {{
              dadosTransferencia?.dadosEnvio?.transportador?.observacao
            }}</span
          >
        </div>
      </div>
    </div>

    <div style="width: 100%; height: 50px" class="row">
      <div class="row text-bold q-pl-sm" style="width: 70%">
        OBSERVAÇÕES: {{ dadosTransferencia?.dadosBasicos?.observacao }}
      </div>
    </div>

    <div style="width: 100%" class="row border-top">
      <div class="column border-right" style="width: 50%">
        <div style="width: 100%" class="row border-bottom">
          <span style="width: 30%" class="border-right text-bold q-pl-sm"
            >NOME:</span
          >
          <span
            v-if="dadoPessoas?.expedidor?.nome"
            class="row justify-center text-bold"
            style="width: 70%"
            >{{ dadoPessoas?.expedidor?.nome }}</span
          >
        </div>
        <div class="row border-bottom" style="width: 100%">
          <span style="width: 30%" class="border-right text-bold q-pl-sm"
            >MATRICULA:</span
          >
          <span
            class="row justify-center text-bold"
            v-if="dadoPessoas?.expedidor?.matricula"
            style="width: 70%"
            >{{ dadoPessoas?.expedidor?.matricula }}</span
          >
        </div>
        <div class="row border-bottom" style="height: 60px">
          <span
            style="width: 30%"
            class="text-bold border-right q-pl-sm row items-center"
            >ASSINATURA:</span
          >
          <span style="width: 70%"></span>
        </div>
      </div>
      <div class="column" style="width: 50%">
        <div style="width: 100%" class="row border-bottom">
          <span style="width: 30%" class="text-bold border-right q-pl-sm"
            >NOME:</span
          >
          <span
            v-if="dadoPessoas?.solicitante?.nome"
            class="row justify-center text-bold"
            style="width: 70%"
            >{{ dadoPessoas?.solicitante?.nome }}</span
          >
        </div>
        <div class="row border-bottom">
          <span style="width: 30%" class="text-bold border-right q-pl-sm"
            >MATRICULA:</span
          >
          <span
            v-if="dadoPessoas?.solicitante?.matricula"
            class="row justify-center text-bold"
            style="width: 70%"
            >{{ dadoPessoas?.solicitante?.matricula }}</span
          >
        </div>
        <div class="row border-bottom" style="height: 60px">
          <span
            style="width: 30%"
            class="text-bold border-right q-pl-sm row items-center"
            >ASSINATURA:</span
          >
          <span style="width: 70%"></span>
        </div>
      </div>
    </div>

    <div style="width: 100%" class="row">
      <div style="width: 50%">
        <span
          class="text-bold border-right row justify-center q-pl-sm"
          style="width: 100%"
          >EXPEDIDOR</span
        >
      </div>
      <div style="width: 50%">
        <span class="text-bold row justify-center q-pl-sm" style="width: 100%"
          >SOLICITANTE</span
        >
      </div>
    </div>
  </main>
  <div v-else style="width: 100%; height: 100%; overflow: scroll">
    <main class="base espacamento" id="base-mobile">
      <div class="column">
        <div style="width: 100%" class="row border-bottom">
          <div
            style="width: 20%"
            class="row border-right container-img items-center"
          >
            <img
              class="img-logo"
              :src="$store.state.autenticacao.logo.logoImpressao"
              alt=""
              fit="contain"
              crossorigin="*"
            />
          </div>
          <div style="width: 40%" class="row border-right q-pa-sm">
            <span class="row col-12 texto-titulo text-bold">
              Acciona Construcción S.A.
            </span>
            <div class="row col-12">
              <div class="col-8">
                <span class="row texto-titulo-secundario"
                  >Rua Olimpiadas, 134, 7º Andar - Vila Olimpia</span
                >
                <span class="row texto-titulo-secundario"
                  >São Paulo - SP - CEP: 04.551-100 - FONE: (11) 3047-2902</span
                >
              </div>
              <div class="col">
                <span class="row justify-end texto-titulo-secundario"
                  >CNPJ: 03.503.152/0014-10</span
                >
                <span class="row justify-end texto-titulo-secundario"
                  >IE: 128.593.586.115</span
                >
              </div>
            </div>
          </div>
          <div style="width: 20%" class="row border-right q-pa-sm">
            <span class="row col-12">
              <span class="row col-12 texto-titulo justify-center text-bold">
                DATAS
              </span>
              <span class="row col-12 texto-titulo-secundario justify-center">
                Impressão: {{ data?.dataAtual }}
              </span>
              <span class="row col-12 texto-titulo-secundario justify-center">
                Criação:
                {{
                  dadosTransferencia?.dadosBasicos?.criadoEm
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </span>
            </span>
          </div>
          <div style="width: 20%" class="row q-pa-sm">
            <span class="row col-12">
              <span class="row col-12 texto-titulo text-bold justify-center">
                Nº TRANSFERÊNCIA
              </span>
              <span
                class="row col-12 texto-numero-transferencia text-bold justify-center"
              >
                {{ dadosTransferencia?.dadosBasicos?.numero }}
              </span>
            </span>
          </div>
        </div>
        <div style="width: 100%" class="row q-mt-sm">
          <div class="row" style="width: 100%">
            <span
              class="row text-bold border-top border-right"
              style="width: 20%"
              ><span class="q-ml-sm texto-titulo"> ORIGEM: </span></span
            >
            <span
              class="text-bold border-right border-top row justify-center"
              style="width: 30%"
            >
              {{ dadosTransferencia?.dadosBasicos.unidadeNomeOrigem }}
            </span>
            <span
              class="text-bold border-right border-top row justify-center"
              style="width: 30%"
            >
              {{
                `${enderecoUnidade.origem?.endereco}, ${enderecoUnidade.origem?.municipio}-${enderecoUnidade.origem?.uf}`
              }}
            </span>
          </div>
          <div class="row" style="width: 100%">
            <span
              class="row text-bold border-top border-bottom border-right"
              style="width: 20%"
              ><span class="q-ml-sm texto-titulo"> DESTINO: </span></span
            >
            <span
              class="text-bold border-right border-top border-bottom row justify-center"
              style="width: 30%"
            >
              {{ dadosTransferencia?.dadosBasicos.unidadeNomeDestino }}
            </span>
            <span
              class="text-bold border-right border-top border-bottom row justify-center"
              style="width: 30%"
            >
              {{
                `${enderecoUnidade.destino?.endereco}, ${enderecoUnidade.destino?.municipio}-${enderecoUnidade.destino?.uf}`
              }}
            </span>
          </div>
        </div>
      </div>

      <div style="width: 100%" class="q-mt-md border-top conteudo-tabela">
        <div style="width: 100%" class="row border-top border-bottom">
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 10%"
            >ITEM</span
          >
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 15%"
            >CÓDIGO</span
          >
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 15%"
            >DESCRIÇÃO</span
          >
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 10%"
            >Nº PATRIMÔNIO
          </span>
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 10%"
            >PATRIMÔNIO SUB
          </span>
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 10%; border-right: 1px solid black"
            >OPERAÇÃO</span
          >
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 15%"
            >FORNECEDOR
          </span>
          <span
            class="text-bold border-right row justify-center bg-grey-5"
            style="width: 15%"
            >ACESSÓRIOS
          </span>
        </div>

        <section style="width: 100%" v-if="dadosTransferencia?.ativos">
          <div
            v-for="(ativo, index) in dadosTransferencia?.ativos"
            :key="index"
            style="width: 100%"
            :class="{ quebra: index == 32 || (index + 1) % 75 == 0 }"
            class="row border-top border-bottom"
          >
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 10%"
              >{{ index + 1 }}</span
            >
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 15%"
              >{{ ativo?.ativoFinal?.catalogoItem?.codigo }}</span
            >
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 15%"
              >{{ ativo?.ativoFinal?.catalogoItem?.nome }}</span
            >
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 10%"
              ><span>
                {{ ativo?.ativoFinal?.patrimonioSubInicial }}
              </span>
            </span>
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 10%"
              ><span>{{ ativo?.ativoFinal?.patrimonio }}</span>
            </span>
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 10%"
              >{{ ativo?.operacao?.nome }}
            </span>
            <span
              class="text-bold border-right items-center row justify-center"
              style="width: 15%"
            >
              {{ ativo?.ativoFinal?.fornecedorNome }}
            </span>
            <span style="width: 15%" class="row text-bold">
              <div
                class="q-ml-sm"
                v-if="ativo?.respostasAcessorioEnvio?.length > 0"
              >
                <div
                  v-for="(acessorio, index) in ativo?.respostasAcessorioEnvio"
                  :key="index"
                >
                  <div>
                    <span
                      >{{ acessorio?.nome }} -
                      {{
                        acessorio?.resposta == "sim" ? "Presente" : "Ausente"
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </span>
          </div>
        </section>
      </div>

      <div
        v-if="dadoPessoas?.transportador?.nome"
        :style="{ marginTop: 320 / dadosTransferencia?.ativos?.length + 'px' }"
        class="column"
        style="width: 100%"
      >
        <div
          style="width: 100%; height: 60%"
          class="row border-top border-bottom"
        >
          <div style="width: 70%" class="column border-right">
            <div class="row border-bottom">
              <span style="width: 30%" class="text-bold border-right"
                ><span class="q-ml-sm">CONDUTOR:</span></span
              >
              <span
                class="row justify-center text-bold"
                v-if="dadoPessoas?.transportador?.nome"
                style="width: 70%"
                >{{ dadoPessoas?.transportador?.nome }}</span
              >
            </div>
            <div class="row border-bottom">
              <span style="width: 30%" class="text-bold border-right q-pl-sm"
                >MATRICULA:</span
              >
              <span
                class="row justify-center text-bold"
                v-if="dadoPessoas?.transportador?.documento"
                style="width: 70%"
                >{{ dadoPessoas?.transportador?.documento }}</span
              >
            </div>
            <div style="width: 100%" class="row">
              <span style="width: 30%" class="text-bold border-right q-pl-sm"
                >PLACA DO VEICULO:</span
              >
              <span
                class="row justify-center text-bold"
                v-if="dadoPessoas?.transportador?.placaVeiculo"
                style="width: 70%"
                >{{ dadoPessoas?.transportador?.placaVeiculo }}</span
              >
            </div>
          </div>
          <div style="width: 30%">
            <span class="text-bold q-ml-sm" style="width: 100%"
              >OBSERVAÇÃO:
              {{
                dadosTransferencia?.dadosEnvio?.transportador?.observacao
              }}</span
            >
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 50px" class="row">
        <div class="row text-bold q-pl-sm" style="width: 70%">
          OBSERVAÇÕES: {{ dadosTransferencia?.dadosBasicos?.observacao }}
        </div>
      </div>
      <div style="width: 100%" class="row border-top">
        <div class="column border-right" style="width: 50%">
          <div style="width: 100%" class="row border-bottom">
            <span style="width: 30%" class="border-right text-bold q-pl-sm"
              >NOME:</span
            >
            <span
              v-if="dadoPessoas?.expedidor?.nome"
              class="row justify-center text-bold"
              style="width: 70%"
              >{{ dadoPessoas?.expedidor?.nome }}</span
            >
          </div>
          <div class="row border-bottom" style="width: 100%">
            <span style="width: 30%" class="border-right text-bold q-pl-sm"
              >MATRICULA:</span
            >
            <span
              class="row justify-center text-bold"
              v-if="dadoPessoas?.expedidor?.matricula"
              style="width: 70%"
              >{{ dadoPessoas?.expedidor?.matricula }}</span
            >
          </div>
          <div class="row border-bottom" style="width: 100%">
            <span style="width: 30%" class="border-right text-bold q-pl-sm">
              ASSINATURA:</span
            >
            <span style="width: 70%"></span>
          </div>
        </div>
        <div class="column" style="width: 50%">
          <div style="width: 100%" class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right q-pl-sm"
              >NOME:</span
            >
            <span
              v-if="dadoPessoas?.solicitante?.nome"
              class="row justify-center text-bold"
              style="width: 70%"
              >{{ dadoPessoas?.solicitante?.nome }}</span
            >
          </div>
          <div class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right q-pl-sm"
              >MATRICULA:</span
            >
            <span
              v-if="dadoPessoas?.solicitante?.matricula"
              class="row justify-center text-bold"
              style="width: 70%"
              >{{ dadoPessoas?.solicitante?.matricula }}</span
            >
          </div>
          <div class="row border-bottom">
            <span style="width: 30%" class="text-bold border-right q-pl-sm"
              >ASSINATURA:</span
            >
            <span style="width: 70%"></span>
          </div>
        </div>
      </div>

      <div style="width: 100%" class="row">
        <div style="width: 50%">
          <span
            class="text-bold border-right row justify-center q-pl-sm"
            style="width: 100%"
            >EXPEDIDOR</span
          >
        </div>
        <div style="width: 50%">
          <span class="text-bold row justify-center q-pl-sm" style="width: 100%"
            >SOLICITANTE</span
          >
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default {
  setup() {
    const store = useStore();
    const $route = useRoute();
    const quasar = useQuasar();

    const transferenciaId = $route.params.transferenciaId;
    const dadosTransferencia = ref();
    const dadosTransferenciaSimplificada = ref();
    const dadoPessoas = ref({
      expedidor: {},
      solicitante: {},
      transportador: {},
    });
    const data = ref({
      dataAtual: new Date().toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
    });
    const enderecoUnidade = ref({
      origem: "",
      destino: "",
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }
    //const router = useRouter();

    const detalharTransferenciaInterna = async () => {
      try {
        store.dispatch("pdt/hiddenHeader", false);
        const response = await store.dispatch(
          "ferramentaria/detalharTransferencia",
          {
            transferenciaUuid: transferenciaId,
          }
        );
        dadosTransferencia.value = response.data.resultado.dados;
        dadosTransferencia.value.ativos.sort((a, b) => {
          if (
            a.ativoFinal.catalogoItem.codigo > b.ativoFinal.catalogoItem.codigo
          ) {
            return 1;
          }
          if (
            a.ativoFinal.catalogoItem.codigo < b.ativoFinal.catalogoItem.codigo
          ) {
            return -1;
          }
          return 0;
        });
        adicionarNomeAcessorioObjetoResposta();
        montarDadoPessoa(
          dadosTransferencia.value.pessoas,
          dadosTransferencia.value.transportador
        );
        receberPatrimonioSubstituidoAtivo(
          dadosTransferencia.value.dadosBasicos.criadoEm.split(" ")[0]
        );
        buscarEnderecoUnidade([
          dadosTransferencia.value.dadosBasicos?.unidadeIdOrigem,
          dadosTransferencia.value.dadosBasicos?.unidadeIdDestino,
        ]);
        if (mobile.value) {
          zoomOut();
        }
        await detalharTransferenciaInternaSimplificada();
        salvarPdf();
      } catch (error) {
        console.log(error);
      }
    };

    const detalharTransferenciaInternaSimplificada = async () => {
      try {
        const response = await store.dispatch(
          "ferramentaria/detalharTransferenciaSimplificada",
          {
            transferenciaUuid: transferenciaId,
          }
        );
        dadosTransferenciaSimplificada.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const receberPatrimonioSubstituidoAtivo = (dataTransferencia) => {
      dadosTransferencia.value.ativos.forEach((ativo) => {
        listarHistoricoAtivo(ativo.ativoFinal.ativoUuid, dataTransferencia);
      });
    };

    const zoomOut = () => {
      const content = document.getElementById("base-mobile");
      content.style.transform = "scale(1)";
      content.style.width = `300%`;
      content.style.height = `100%`;
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const centerX = (windowWidth - content.clientWidth) / 2;
      const centerY = (windowHeight - content.clientHeight) / 2;

      content.style.transformOrigin = "top left";
      content.style.left = centerX + "px";
      content.style.top = centerY + "px";
    };

    const salvarPdf = async () => {
      quasar.notify({
        message: "Aguarde enquanto o PDF é gerado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      setTimeout(() => {
        let data = document.getElementById(
          mobile.value ? "base-mobile" : "base"
        );
        var hoje = new Date();
        let dataGerado = `${hoje.getDate()}/${hoje.getMonth()}/${hoje.getFullYear()} ${hoje.getHours()}:${
          hoje.getMinutes() /* < 10 ? "0" + hoje.getMinutes() : hoje.getMinutes()*/
        }:${hoje.getMilliseconds()}`;
        html2canvas(data, {
          useCORS: true,
        }).then((canvas) => {
          var imgWidth = 295;
          var pageHeight = 210;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;

          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/jpeg");

          var doc = new jsPDF("l", "mm", "a4", true);
          var position = 2;
          doc.addImage(
            imgData,
            "JPEG",
            1,
            position,
            imgWidth - 0,
            imgHeight + 0
          );
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(
              imgData,
              "JPEG",
              1,
              position,
              imgWidth - 0,
              imgHeight + 0
            );
            heightLeft -= pageHeight;
          }
          doc.save(
            `transferencia_interna_${dadosTransferencia?.value?.dadosBasicos?.numero}_${dataGerado}`
          );
        });
      }, 2000);
    };

    const listarHistoricoAtivo = async (ativoUuid, dataTransferencia) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarMovimentacaoAtivo",
          {
            ativoUuid,
            chave: "patrimonio",
            alteradoEm: dataTransferencia,
          }
        );
        if (response.data.resultado.dados.length > 0) {
          let patrimonioFinal = response.data.resultado.dados[0].valorFinal;
          let patrimonioInicial = response.data.resultado.dados[0].valorInicial;
          dadosTransferencia.value.ativos.forEach((ativo) => {
            if (ativo.ativoFinal.ativoUuid == ativoUuid) {
              ativo.ativoFinal.patrimonioSubFinal = patrimonioFinal;
              ativo.ativoFinal.patrimonioSubInicial = patrimonioInicial;
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarNomeAcessorioObjetoResposta = () => {
      dadosTransferencia.value.ativos.forEach((ativo) => {
        if (ativo.respostasAcessorioEnvio.length > 0) {
          ativo.respostasAcessorioEnvio.forEach((acessorio) => {
            let nome = ativo.ativoInicial.acessorios.filter(
              (value) => value.uuid === acessorio.ativoAcessorioUuid
            );
            acessorio.nome = nome[0].nome;
          });
        }
      });
    };

    const montarDadoPessoa = (array, transportador) => {
      let expedidor = array.filter((pessoa) => pessoa.tipo == "expedidor");
      let solicitante = array.filter((pessoa) => pessoa.tipo == "solicitante");
      dadoPessoas.value = {
        expedidor: expedidor[0],
        transportador: transportador,
        solicitante: solicitante[0],
      };
    };

    const buscarEnderecoUnidade = async (array) => {
      array.forEach((id, index) => {
        listarUnidades(id, index);
      });
    };

    const listarUnidades = async (id, index) => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        let unidades = response.listaUnidades;
        let unidadeEspecifica = unidades.filter((unidade) => unidade.id == id);
        if (index == 0) {
          enderecoUnidade.value.origem = unidadeEspecifica[0]?.endereco;
          return;
        }
        enderecoUnidade.value.destino = unidadeEspecifica[0]?.endereco;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(() => {
      detalharTransferenciaInterna();
    });

    return {
      detalharTransferenciaInterna,
      data,
      dadosTransferencia,
      transferenciaId,
      dadoPessoas,
      buscarEnderecoUnidade,
      adicionarNomeAcessorioObjetoResposta,
      listarHistoricoAtivo,
      receberPatrimonioSubstituidoAtivo,
      listarUnidades,
      salvarPdf,
      enderecoUnidade,
      mobile,
      dadosTransferenciaSimplificada,
    };
  },
};
</script>

<style>
.base {
  border: 1px solid black;
}

.border-left {
  border-left: 1px solid black;
}

.border-right {
  border-right: 1px solid black;
}

.border-bottom {
  border-bottom: 1px solid black;
}

.border-top {
  border-top: 1px solid black;
}

.align {
  align-items: center;
}

.quebra {
  page-break-after: always !important;
}
.img-logo {
  height: 100%;
  width: 100%;
}
.text-logo {
  font-size: 40px;
  font-weight: bold;
}
.container-img {
  padding: 10px;
}
.texto-titulo {
  font-size: 18px;
}
.texto-titulo-secundario {
  font-size: 15px;
}
.texto-numero-transferencia {
  font-size: 21px;
}
@page {
  margin: 0.9mm;
  size: 290.7mm 210mm;
}
@media print {
  .espacamento {
    margin: 0px;
  }
  .conteudo-tabela {
    font-size: 11px;
  }
  div .text-logo {
    font-size: 37px !important;
    font-weight: bold;
  }
  .size {
    font-size: 11px !important;
  }
  .img-logo {
    height: 60px;
    width: 150px;
  }
  .texto-titulo {
    font-size: 12px;
  }
  .texto-titulo-secundario {
    font-size: 10px;
  }
  .texto-numero-transferencia {
    font-size: 14px;
  }
}
</style>
